import { CardType } from '@core/types/card-deck';
import { H2 } from '@shared/components/Heading';
import Paragraph from '@shared/components/Paragraph';
import { FC } from 'react';

import CardHandler from './CardHandler';

const Prinzipien: FC = () => (
  <CardHandler type={CardType.Principle}>
    <H2>Prinzipien, statt Techniken</H2>
    <Paragraph>Unser Training basiert auf Prinzipien. Hier sind einige davon.</Paragraph>
    <Paragraph>
      Während viele Trainings hauptsächlich Techniken unterrichten, geht es im Systema eher um das
      Verständnis von generellen Ideen und Konzepten. Das nennen wir Prinzipien. Einem solchen
      Prinzip lassen sich dann verschiedene Techniken zuordnen, die alle diesem Prinzip folgen.
      Durch diesen Ansatz wird das Training freier, da Bewegungen nicht genau vom Lehrer vorgegeben
      werden. Vielmehr werden Ideen geteilt, die alle Teilnehmer dann individuell für sich umsetzen.
      <br />
      <br />
      Klicke auf die einzelnen Bilder, um mehr Informationen anzuzeigen.
    </Paragraph>
  </CardHandler>
);

export default Prinzipien;
